import React from 'react'

function Article(props) {
  return (
    <article>
  <h3>Snake looking letters</h3>
  <p>These letters are as pretty as snakes.</p>
  <p>This is H: ح, kh: خ, zh: ج. </p>
  <p>These are tricky to pronounce correctly. Only ج is found in English.
  It is then pronounced as <i>si</i> in <i>vision</i></p>
  <p>We suggest that you practice pronuncing these. </p>
    </article>
  )
}

export default Article
